import type { GameEvent } from "@/types"
import { kazdelEvents } from "./kazdel"
import { leithaniaEvents } from "./leithania"
import { rhodesEvents } from "./rhodes"
import { samiEvents } from "./sami"
import { sargonEvents } from "./sargon"
import { ursusEvents } from "./ursus"
import { victoriaEvents } from "./victoria"

const allEvents: Record<string, GameEvent> = {
    ...kazdelEvents,
    ...sargonEvents,
    ...samiEvents,
    ...leithaniaEvents,
    ...ursusEvents,
    ...victoriaEvents,
    ...rhodesEvents,
}

export function getEventById(eventId: string): GameEvent | undefined {
    return allEvents[eventId]
}

export function getEventByGalleryId(galleryId: string): GameEvent | undefined {
    return Object.values(allEvents).find(
        (event) => event.unlockGalleryId === galleryId,
    )
}
